import { User } from './user';

export class Note {
  constructor(data) {
    this.id = data.id;
    this.registrationId = data.registrationId;
    this.typeId = data.typeId;
    this.userId = data.userId;
    this.createDate = data.createDate;
    this.editDate = data.editDate;
    this.isActive = data.isActive;
    this.note = data.note;

    /** @type {User | null} */
    this.user = data.user;
  }
}

export class NoteCreation {
  constructor(data) {
    this.note = data.note;
  }
}
